import Vue from 'vue'
import httpManager from '../../util/common'
import XEUtils from "xe-utils";

let vm = {
  delimiters: ['{', '}'],
  props: {},
  data: () => {
    return {
      panes_data: [],
    }
  },
  methods: {
    getStat() {
      this.panes = [
        {'title': this.$t('home.listed_company_number'), key: 'securities_entity', data:0},
        {'title': this.$t('home.issuing_company_number'), key: 'bond_entity', data:0},
        {'title': this.$t('home.participate_esg_company_number'), key: 'esg_entity', data:0},
        {'title': this.$t('home.supply_chain_info_amount'), key: 'sc', data:0},
        {'title': this.$t('home.listed_company_patent_number'), key: 'patent_securities', data:0},
        {'title': this.$t('home.esg_public_number'), key: 'news', data:0}
      ]
      let self = this
      let items = []
      for(let i in self.panes){
        items[i]=self.panes[i].key
      }
      let params = new Map()
      params.set("items", items)
      httpManager("data_stat", params)
        .then(response => {
          let data = response.data.data
          for(let ind in self.panes){
            let pane = self.panes[ind]
            let key = pane.key
            for(let index in data){
              let d = data[index]
              let k = d.statistics_item
              if(k === key){
                pane.data = XEUtils.commafy(XEUtils.toNumber(d.item_value), { digits: 0 })
                self.panes_data.push(pane.data)
                pane.title = d.item_name
                break
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },

  },
  mounted() {
    this.getStat()
  },
  computed:{
    panes() {
      if(this.panes_data.length > 0)
        return [
          {'title': this.$t('home.listed_company_number'), key: 'securities_entity', data:this.panes_data[0]},
          {'title': this.$t('home.issuing_company_number'), key: 'bond_entity', data:this.panes_data[1]},
          {'title': this.$t('home.participate_esg_company_number'), key: 'esg_entity', data:this.panes_data[2]},
          {'title': this.$t('home.supply_chain_info_amount'), key: 'sc', data:this.panes_data[3]},
          {'title': this.$t('home.listed_company_patent_number'), key: 'patent_securities', data:this.panes_data[4]},
          {'title': this.$t('home.esg_public_number'), key: 'news', data: this.panes_data[5]}

        ]
      else return [
        {'title': this.$t('home.listed_company_number'), key: 'securities_entity', data:0},
        {'title': this.$t('home.issuing_company_number'), key: 'bond_entity', data:0},
        {'title': this.$t('home.participate_esg_company_number'), key: 'esg_entity', data:0},
        {'title': this.$t('home.supply_chain_info_amount'), key: 'sc', data:0},
        {'title': this.$t('home.listed_company_patent_number'), key: 'patent_securities', data:0},
        {'title': this.$t('home.esg_public_number'), key: 'news', data:0}

      ]
    }
  }
}
Vue.component("data-statis-board", vm)
export default vm



// WEBPACK FOOTER //
// ./src/home/js/data_statis_board.js